const moment = require("moment");
const {fsMomentImport} = require("../utils/utils");


class Note {

    constructor({
                    id = '',
                    ref = '',
                    content = null,
                    created = moment(),
                    createdBy = '',
                    updated = moment(),
                    updatedBy = '',
                    comment= [],
                } = {}) {

        this.id = id;
        this.ref = ref;
        this._content = content;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.created = null;
        this.updated = null;
        const field = ['created', 'updated'];
        [created, updated].forEach((date, index) => {
            date = fsMomentImport(date)
            this[field[index]] = date && date.isValid() ? date : moment()
        })
        this.comment = Array.isArray(comment) ? content : []
    }

    static get FS_COLLECTION_NAME() {
        return 'note'
    }


    get content() {
        return this._content ? this._content : {blocks: [], entityMap: {}}
    }

    set content(value) {
        this._content = value;
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);

            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }

            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute.replace('_', '')) {
                case 'id':
                    return (typeof this[attribute] === 'string');
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating address with error:', e, attribute);
            return false
        }
    }

    static parseFirestore(note, id) {
        return new Note({
            ...note,
            id: id ? id : note.id,
            comment: Array.isArray(note.comment) ?
                note.comment.map((c) => Note.parseFirestore(c)) : []
        })
    }

    static fromFirestore(fsSnap) {

        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = Note.parseFirestore(fsSnap[key], key);
                }
            });
        }

        return data
    }


    toFirestore() {
        return {
            id: this.id,
            ref: this.ref,
            content: this._content,
            created: this.created && (typeof this.created.toDate === 'function') ? this.created.toDate() : null,
            createdBy: this.createdBy,
            updated: this.updated && (typeof this.updated.toDate === 'function') ? this.updated.toDate() : null,
            updatedBy: this.updatedBy,
        }
    }
}

module.exports = Note;